function ManagedError() {
}

ManagedError.prototype = Object.create(Error.prototype);
ManagedError.prototype.constructor = ManagedError;

export default ManagedError;



// WEBPACK FOOTER //
// ./src/library/domain/ManagedError.js